import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

function cleanParams(filters = {}) {
  const p = {};
  if (filters.date_from)   p.date_from   = filters.date_from;
  if (filters.date_to)     p.date_to     = filters.date_to;
  if (filters.statuses)    p.statuses    = filters.statuses;
  if (filters.search)      p.search      = filters.search;
  if (filters.zoddle_size) p.zoddle_size = filters.zoddle_size;
  if (filters.limit != null)  p.limit  = filters.limit;
  if (filters.offset != null) p.offset = filters.offset;
  return p;
}

export async function listPastOrders(filters = {}) {
  const res = await axios.get(`${API}/past-orders`, {
    headers: authHeader(), params: cleanParams(filters),
  });
  return res.data;
}

export async function pastOrdersSummary(filters = {}) {
  const res = await axios.get(`${API}/past-orders-summary`, {
    headers: authHeader(), params: cleanParams(filters),
  });
  return res.data;
}

export async function getOrderByUid(uid) {
  const res = await axios.get(`${API}/past-orders/by-uid/${encodeURIComponent(uid)}`, {
    headers: authHeader(),
  });
  return res.data;
}

export async function getOrderBySheetId(sheetOrderId) {
  const res = await axios.get(
    `${API}/past-orders/by-sheet-id/${encodeURIComponent(sheetOrderId)}`,
    { headers: authHeader() }
  );
  return res.data;
}

export async function syncNew() {
  const res = await axios.post(`${API}/past-orders/sync-new`, {}, {
    headers: authHeader(),
  });
  return res.data;
}

export async function resyncByUid(uid) {
  const res = await axios.post(
    `${API}/past-orders/by-uid/${encodeURIComponent(uid)}/resync`, {},
    { headers: authHeader() }
  );
  return res.data;
}

export async function listCustomerReturns() {
  const res = await axios.get(`${API}/past-orders/returns`, {
    headers: authHeader(), params: { limit: 200 },
  });
  return res.data;
}

export async function listWriteoffs() {
  const res = await axios.get(`${API}/past-orders/writeoffs`, {
    headers: authHeader(), params: { limit: 200 },
  });
  return res.data;
}
